import { ApplicationAccessType, CommunicationType } from 'domains/content/types';
import { ContentStatus } from 'pages/ContentPage/ContentTable/ContentStatusText';

export type VoiceText = { text: string; type: 'text' };
type VoiceAudio = { url: string; type: 'audio' };
type PlayMessageContentType = VoiceText | VoiceAudio;

export enum VoiceContentAction {
    PLAY_MESSAGE = 'play_message',
    DO_NOT_DISTURB = 'do_not_disturb',
    TRANSFER = 'transfer',
    VOICEMAIL = 'voicemail',
}

export enum NoResponseAction {
    HANG_UP = 'hang_up',
    REPEAT = 'repeat',
}

export type VoiceCallRoot = {
    interactions: VoiceContentInteraction[];
    message: PlayMessageContentType[];
    type: VoiceContentAction.PLAY_MESSAGE;
};

type BaseInteraction = {
    keypadOption: string;
    type?: VoiceContentAction;
    message?: PlayMessageContentType[];
    transferNumber?: string;
};

export type MessageInteraction = {
    keypadOption: string;
    message: PlayMessageContentType[];
    type: VoiceContentAction.PLAY_MESSAGE | VoiceContentAction.DO_NOT_DISTURB;
};

type TransferInteraction = {
    keypadOption: string;
    transferNumber: string;
    type: VoiceContentAction.TRANSFER;
};

export type VoicemailInteraction = {
    message: PlayMessageContentType[];
    type: VoiceContentAction.VOICEMAIL;
};

export type VoiceContentInteraction = BaseInteraction | MessageInteraction | TransferInteraction;

export type VoiceCallFallback = {
    waitTime: 2 | 3 | 4 | 5;
    repeat: 0 | 1 | 2;
    timeoutMessage: string;
    incorrectResponseMessage: string;
};

export type VoiceContentStateTypes = {
    name: string;
    voiceJson: {
        voiceCall: VoiceCallRoot;
        voicemail?: VoicemailInteraction;
        fallback?: VoiceCallFallback;
    };
    applicationsAccess: ApplicationAccessType[];
    communicationType: CommunicationType;
    status?: ContentStatus;
};
